import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const AssiduiteFilters = ({ 
  showFilters, 
  filters, 
  setFilters, 
  setShowFilters, 
  classes, 
  niveaux, 
  filieres 
}) => {
  if (!showFilters) return null;

  return (
    <div className="mt-4 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
      <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Classe</label>
          <div className="relative">
            <select
              value={filters.classe}
              onChange={(e) => setFilters({ ...filters, classe: e.target.value })}
              className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm 
              focus:outline-none focus:ring-2 focus:ring-[#202654]/50 focus:border-[#202654] 
              transition duration-200 ease-in-out"
            >
              <option value="">Toutes les classes</option>
              {(classes || []).map((classe) => (
                <option key={classe.id} value={classe.id}>
                  {classe.libelle}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Niveau</label>
          <div className="relative">
            <select
              value={filters.niveau}
              onChange={(e) => setFilters({ ...filters, niveau: e.target.value })}
              className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm 
              focus:outline-none focus:ring-2 focus:ring-[#202654]/50 focus:border-[#202654] 
              transition duration-200 ease-in-out"
            >
              <option value="">Tous les niveaux</option>
              {(niveaux || []).map((niveau) => (
                <option key={niveau.id} value={niveau.id}>
                  {niveau.libelle}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Filière</label>
          <div className="relative">
            <select
              value={filters.filiere}
              onChange={(e) => setFilters({ ...filters, filiere: e.target.value })}
              className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm 
              focus:outline-none focus:ring-2 focus:ring-[#202654]/50 focus:border-[#202654] 
              transition duration-200 ease-in-out"
            >
              <option value="">Toutes les filières</option>
              {(filieres || []).map((filiere) => (
                <option key={filiere.id} value={filiere.id}>
                  {filiere.libelle}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
        </div>

        <div className="col-span-1 md:col-span-3 flex flex-row gap-2 items-end mt-2">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Date début</label>
            <div className="relative">
              <DatePicker
                selected={filters.dateDebut}
                onChange={(date) => setFilters({ ...filters, dateDebut: date })}
                className="block w-full pl-3 pr-10 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#202654]/50 focus:border-[#202654] transition duration-200 ease-in-out text-sm"
                dateFormat="dd/MM/yyyy"
                placeholderText="Sélectionner une date"
                isClearable
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg className="h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Date fin</label>
            <div className="relative">
              <DatePicker
                selected={filters.dateFin}
                onChange={(date) => setFilters({ ...filters, dateFin: date })}
                className="block w-full pl-3 pr-10 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#202654]/50 focus:border-[#202654] transition duration-200 ease-in-out text-sm"
                dateFormat="dd/MM/yyyy"
                placeholderText="Sélectionner une date"
                isClearable
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg className="h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 pb-6 flex justify-end space-x-4">
        <button
          type="button"
          onClick={() => {
            // Reset all filters
            setFilters({
              classe: '',
              niveau: '',
              filiere: '',
              dateDebut: null,
              dateFin: null
            });
          }}
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
        >
          Réinitialiser
        </button>
        <button
          type="button"
          onClick={() => setShowFilters(false)}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#202654] hover:bg-[#161c3f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
        >
          Appliquer
        </button>
      </div>
    </div>
  );
};

export default AssiduiteFilters;
